import { Skeleton } from '@/shared/ui/atoms';

/** Esqueleto exibido enquanto os detalhes da resposta carregam ou o modal navega. */
export function SkeletonContent() {
  return (
    <div className="divide-y flex flex-col divide-ctx-layout-border">
      <section className="px-lg py-md">
        <Skeleton className="mb-sm h-mini w-full" />
        <Skeleton className="h-mini w-5/6" />
      </section>
      <section className="px-lg py-md">
        <Skeleton className="w-24 mb-md h-mini" />
        <div className="mb-md flex items-center justify-between">
          <div className="flex items-center gap-sm">
            <Skeleton shape="circle" className="size-md shrink-0" />
            <Skeleton className="w-32 h-mini" />
          </div>
          <Skeleton className="w-10 h-xxs" />
        </div>
        <Skeleton className="h-[3rem] w-full rounded-sm" />
      </section>
    </div>
  );
}
